import React from 'react';
import { VscSmiley } from 'react-icons/vsc';
import { Link } from 'react-router-dom';
import styles from './ThankYou.module.scss';

const ThankYou = () => (
  <div className={styles.container}>
    <div className={styles.icon}><VscSmiley size="5rem" /></div>
    <div className={styles.title}>Thank you for shopping with us</div>
    <div className={styles.button}>
      {' '}
      <Link to="/" className={styles.linkStyle}>Continue shopping</Link>
    </div>
  </div>
);

export default ThankYou;
